<template>
  <div class="app-options-wrapper">
    <BookTariffOptionsWrapper :extra-tariff-options="extraData.tariffOptions" :extra-status="extraData.status">
      <template v-for="slot in possibleChildSlotsFor('Tariff')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </BookTariffOptionsWrapper>
    <ServiceOptionsWrapper :filter-service-options="extraData.serviceOptions">
      <template v-for="slot in possibleChildSlotsFor('Service')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ServiceOptionsWrapper>
  </div>
</template>

<script>
import slotProxy from '@/mixins/slotProxy'
import ServiceOptionsWrapper from '../ServiceOptions/ServiceOptionsWrapper.vue'
import BookTariffOptionsWrapper from '../../rossmann/BookTariffOptionsWrapper.vue'
import extraData from '../../../../../../mixins/extraData'

export default {
  name: 'OptionsWrapper',
  components: { ServiceOptionsWrapper, BookTariffOptionsWrapper },
  mixins: [
    slotProxy(),
    extraData()
  ]
}
</script>
